import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { PreventivoRow } from "../../services/preventiviApi";
import { hasValidMatch } from "../../utils/matchSelection";

interface CloseConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  rows: PreventivoRow[];
  loading: boolean;
}

export const CloseConfirmDialog: React.FC<CloseConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  rows,
  loading,
}) => {
  const itemRows = rows.filter((r) => (r.row_type ?? "item") === "item");
  const confirmed = itemRows.filter(hasValidMatch).length;
  const manual = itemRows.filter((r) => !r.selected_item_uid && r.overridden_metadata).length;
  const withOverrides = itemRows.filter((r) => r.selected_item_uid && r.overridden_metadata).length;

  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "1rem" } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <WarningAmberIcon sx={{ color: "#E65100" }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Chiudi preventivo
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Questa operazione è <strong>irreversibile</strong> e creerà nuovi item nel catalogo.
        </Alert>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">Righe con match confermato</Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{confirmed}</Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">Righe con metadata modificati</Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{withOverrides}</Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">Righe inserite manualmente</Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{manual}</Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">Totale righe</Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{itemRows.length}</Typography>
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2.5 }}>
          Tutti gli item abbinati verranno aggiunti al catalogo e al database di feedback. 
          I feedback positivi verranno registrati per migliorare le suggerimenti futuri.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} disabled={loading}>Annulla</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? <CircularProgress size={22} /> : "Chiudi preventivo"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
